module.exports = __webpack_public_path__ + "img/CA.ea23badb.png";